import TLoginPasscodeInput from './index.vue';

TLoginPasscodeInput.install = app => {
  app.component(TLoginPasscodeInput.name, TLoginPasscodeInput);
};

export default TLoginPasscodeInput;
